document.querySelector("#year").innerHTML=(new Date).getFullYear(),document.querySelectorAll('[role="listbox"]').forEach((e=>{e.classList.add("form-control-lg")})),document.querySelectorAll(".select-arrow").forEach((e=>{e.setAttribute("style","top: 13px !important;")}));
//# sourceMappingURL=main-wow.min.js.map
